import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatVal } from '../../../helpers/value'
import { Element } from '../../html/element'
import classes from './index.module.scss'

export const ChartTooltipContent = ({
  data,
  activeIndex,
  label,
  formatNameTooltip,
  formatValueTooltip,
  propsTooltip,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const { styleLabel = {}, styleValue = {} } = propsTooltip

  const renderLabel = () => {
    if (!label) return null
    return (
      <Element className={classes.tooltipLabel} style={{ color: '#ececec' }}>
        <Element style={{ fontSize: 10 }}>{label}</Element>
      </Element>
    )
  }

  const renderContent = () => {
    const activeData = data[activeIndex]
    if (!activeData) return null

    return (
      <Element className={classes.tooltipContent}>
        <Element
          style={{ fontSize: 11, color: '#ececec', ...styleLabel }}
          className={classes.tooltipContentLabel}
        >
          {formatNameTooltip ? (
            formatNameTooltip(activeData.name, { activeData })
          ) : activeData.isI18n ? (
            <Translate value={activeData.name} />
          ) : (
            activeData.name
          )}
          :
        </Element>
        <Element
          style={{ fontSize: 11, color: '#ececec', ...styleValue }}
          className={classes.tooltipContentValue}
        >
          {formatValueTooltip
            ? formatValueTooltip(activeData.value, { activeData, locale })
            : formatVal(activeData.value, locale)}
        </Element>
      </Element>
    )
  }

  return (
    <>
      {renderLabel()}
      {renderContent()}
    </>
  )
}

ChartTooltipContent.propTypes = {
  data: PropTypes.array.isRequired,
}

ChartTooltipContent.defaultProps = {
  data: [],
}
